module.exports = __webpack_public_path__ + "static/media/vip-ticket.db2a2d74.png";